define([
   	"dojo/_base/declare"
], function(declare) {

	return declare(null,{
		// String
		typeName: null,

		// ViewContainer[]
		viewContainers: null,

		constructor: function(typeName) {
			this.typeName = typeName;
			this.viewContainers = [];
		},

		addViewContainer: function(/*ViewContainer*/container) {
			this.viewContainers.push(container);
		}
	});
});